module.exports = __webpack_public_path__ + "img/creditos_button.ff5d7b1d.png";